import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import InfoAccordion from '../../InfoAccordion'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

@observer
class UploadConfirmationModal extends Component {
    render() {
        const { distributeStore } = this.props
        const {
            importDetails,
            verifyEmails,
            hideCompletionModal,
            completionModalVisible,
        } = distributeStore

        const totalRecords = importDetails.numSurveyUsers
        + importDetails.emailDuplicatesInFile.length
        + importDetails.emailDuplicatesInDb.length
        + importDetails.emailsInBlacklist.length

        return (
            <Modal
                show={completionModalVisible}
                onClose={hideCompletionModal}
            >
                <div className="email-list-modal">
                    <i className="far fa-circle-check headericon" />

                    <h2>{i18n.t('uploadConfirmationModal.title')}</h2>

                    <h4>{i18n.t('uploadConfirmationModal.subtitle')}</h4>
                </div>

                <InfoAccordion
                    title="Uploaded statistics"
                    show
                >
                    <p>
                        {i18n.t('sch_upload_statistics_total_records')}
                        :
                        {' '}
                        {totalRecords}
                    </p>

                    <p>
                        {i18n.t('sch_upload_statistics_duplicate')}
                        :
                        {' '}
                        {(importDetails.emailDuplicatesInDb.length + importDetails.emailDuplicatesInFile.length)}
                    </p>

                    <p>
                        {i18n.t('sch_upload_statistics_blacklisted')}
                        :
                        {' '}
                        {importDetails.emailsInBlacklist.length}
                    </p>

                    <p>
                        {i18n.t(
                            verifyEmails
                                ? 'sch_upload_statistics_total_emails_2bimported'
                                : 'sch_upload_statistics_total_emails_2bimported_no_verify',
                        )}
                        :
                        {' '}
                        {importDetails.numSurveyUsers}
                    </p>
                </InfoAccordion>

                <ModalFooter>
                    <div className="create-user-modal-buttons">
                        <Button cssClass="tertiary regular" onClick={hideCompletionModal}>
                            {i18n.t('close')}
                        </Button>

                        <Button cssClass="primary regular" onClick={hideCompletionModal}>
                            {i18n.t('uploadConfirmationModal.confirm')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default UploadConfirmationModal
